import queryString from 'query-string'
import { validateMockedRoles } from '../getTestContext'
import type Keycloak from 'keycloak-js'
import type {
  KeycloakInitOptions,
  KeycloakLoginOptions,
  KeycloakLogoutOptions,
  KeycloakProfile,
  KeycloakRegisterOptions,
  KeycloakUserInfo
} from 'keycloak-js'
import type { Query } from '../types'

const token = 'A random string that is non zero length'

const userProfile = {
  username: 'test',
  email: 'test@keysight.com',
  firstName: 'Test',
  lastName: 'User'
}

const realmAccess = { roles: ['user'] }

const tokenParsed = {
  realm_access: {
    roles: ['dai:user']
  }
}

const adminTokenParsed = {
  realm_access: {
    roles: ['dai:admin']
  }
}

const getTokenParsed = () => {
  const { mockedRoles } = queryString.parse(window.location.search) as Query

  const roles = mockedRoles?.split(',')

  const hasValidMockedRole = validateMockedRoles(roles)

  if (!hasValidMockedRole) return adminTokenParsed

  return {
    realm_access: {
      roles: roles! // after validateMockedRoles roles will not undefiend or empty string
    }
  }
}

const authClient: Keycloak = {
  authenticated: true,
  authServerUrl: 'http://some-auth-server.com/auth/',
  hasRealmRole() {
    return true
  },
  hasResourceRole() {
    return true
  },
  idToken: token,
  profile: userProfile,
  realm: 'eggplant',
  realmAccess,
  refreshToken: token,
  token,
  tokenParsed,
  idTokenParsed: getTokenParsed(),

  init(_initOptions: KeycloakInitOptions): Promise<boolean> {
    throw new Error('Function not implemented.')
  },
  login(_options?: KeycloakLoginOptions | undefined): Promise<void> {
    throw new Error('Function not implemented.')
  },
  logout(_options?: KeycloakLogoutOptions | undefined): Promise<void> {
    throw new Error('Function not implemented.')
  },
  register(_options?: KeycloakRegisterOptions | undefined): Promise<void> {
    throw new Error('Function not implemented.')
  },
  accountManagement(): Promise<void> {
    throw new Error('Function not implemented.')
  },
  createLoginUrl(_options?: KeycloakLoginOptions | undefined): Promise<string> {
    throw new Error('Function not implemented.')
  },
  createLogoutUrl(_options?: KeycloakLogoutOptions | undefined): string {
    throw new Error('Function not implemented.')
  },
  createRegisterUrl(_options?: KeycloakRegisterOptions | undefined): Promise<string> {
    throw new Error('Function not implemented.')
  },
  createAccountUrl(): string {
    throw new Error('Function not implemented.')
  },
  isTokenExpired(_minValidity?: number | undefined): boolean {
    throw new Error('Function not implemented.')
  },
  updateToken(_minValidity: number): Promise<boolean> {
    throw new Error('Function not implemented.')
  },
  clearToken(): void {
    throw new Error('Function not implemented.')
  },
  loadUserProfile(): Promise<KeycloakProfile> {
    throw new Error('Function not implemented.')
  },
  loadUserInfo(): Promise<KeycloakUserInfo> {
    throw new Error('Function not implemented.')
  },
  responseMode: 'query',
  responseType: 'code',
  flow: 'standard',
  timeSkew: null,
  didInitialize: false,
  loginRequired: false
}

export default {
  initialized: true,
  keycloak: authClient
}
